const persianAlphabets = [
  { name: "آ", id: "A" },
  { name: "ا", id: "B" },
  { name: "ب", id: "C" },
  { name: "پ", id: "D" },
  { name: "ت", id: "E" },
  { name: "ث", id: "F" },
  { name: "ج", id: "G" },
  { name: "چ", id: "H" },
  { name: "ح", id: "a" },
  { name: "خ", id: "b" },
  { name: "د", id: "c" },
  { name: "ذ", id: "d" },
  { name: "ر", id: "e" },
  { name: "ز", id: "f" },
  { name: "ژ", id: "g" },
  { name: "س", id: "h" },
  { name: "ش", id: "i" },
  { name: "ص", id: "j" },
  { name: "ض", id: "k" },
  { name: "ط", id: "l" },
  { name: "ظ", id: "m" },
  { name: "ع", id: "n" },
  { name: "غ", id: "o" },
  { name: "ف", id: "p" },
  { name: "ق", id: "q" },
  { name: "ک", id: "r" },
  { name: "گ", id: "s" },
  { name: "ل", id: "t" },
  { name: "م", id: "u" },
  { name: "ن", id: "v" },
  { name: "و", id: "w" },
  { name: "ه", id: "x" },
  { name: "ی", id: "y" },
  { name: "ی", id: "z" },
];

export default persianAlphabets;
